export const SLOT_TYPE = Object.freeze({
  available: 0,
  unavailable: 1,
})
